<template>
    <div class="vx-row w-full mb-6  ">
        <div class="vx-col sm:w-3/5 w-full">
            <div class="flex items-center mb-3">
                <div class="flex items-center ">
                    <datepicker 
                        class="vx-col w-full"
                        placeholder="시작일" 
                        v-model="startDate"
                        :value="startDate"
                        @input="startDate = moment($event).format('YYYY-MM-DD') "
                        format="yyyy-MM-dd"
                        :language="ko"
                        :disabledDates="{from: endDate ? new Date(endDate) : null ,to : endDate ? new Date(moment(endDate).add(-1, 'y').format('YYYY-MM-DD')) : null}"
                        :clear-button='true'
                        :useUtc="true"
                    />
                    <span class="m-1">{{' ~ '}}</span>
                    <datepicker 
                        class="vx-col w-full ml-3"
                        placeholder="종료일" 
                        v-model="endDate"
                        :value="endDate"
                        @input="endDate = fixDate($event,'yyyy-MM-dd')"
                        format="yyyy-MM-dd"
                        :language="ko"
                        :disabledDates="{to: startDate ? new Date(startDate) : null , from: startDate ? new Date(moment(startDate).add(1, 'y').format('YYYY-MM-DD')  ): null}"
                        :clear-button='true'
                    />
                    <v-select class="searchSelect ml-3"  
                        placeholder="접수유형" 
                        v-model='applyTable.source' 
                        :clearable="false" 
                        :options="applyTable.sourceOption"
                        :reduce="optionData => optionData.value"
                        clearable
                    />
                    <v-select class="searchSelect ml-3"
                        placeholder="사이트언어" 
                        v-model='applyTable.language' 
                        :clearable="false" 
                        :options="applyTable.langOption"
                        :reduce="optionData => optionData.value"
                        clearable
                    />
                    
                </div>
            </div>
            <div class="flex items-center mb-3">
                <vs-checkbox  class="inline-flex mt-2" v-model="applyTable._registered" ><div class="con-vs-chip vs-chip-primary con-color" style="
                                cursor : pointer;
                                background-color: #4aa414 !important;
                                color:#fff;
                                line-height:1;
                                padding:3px 10px;
                                margin:10px 0; 
                                font-size:13px;
                                min-width:50px;
                            ">
                                <span style="margin:0" class="text-chip vs-chip--text">
                                발매신청
                            </span><!----></div></vs-checkbox>
                <vs-checkbox  class="inline-flex mt-2" v-model="applyTable._rejected" >
                    <div class="con-vs-chip vs-chip-primary con-color" style="
                            cursor : pointer;
                            background-color: #ba2727 !important;
                            color:#fff;
                            line-height:1;
                            padding:3px 10px;
                            margin:10px 0; 
                            font-size:13px;
                            min-width:50px;
                        ">
                            <span style="margin:0" class="text-chip vs-chip--text">발매거절</span>
                    </div>
                </vs-checkbox>
                <vs-checkbox  class="inline-flex mt-2" v-model="applyTable._onhold" >
                    <div class="con-vs-chip vs-chip-primary con-color" style="
                                cursor : pointer;
                                background-color: #c3a433 !important;
                                color:#fff;
                                line-height:1;
                                padding:3px 10px;
                                margin:10px 0; 
                                font-size:13px;
                                min-width:50px;
                            ">
                                <span style="margin:0" class="text-chip vs-chip--text">
                                발매보류
                            </span><!----></div></vs-checkbox>
                <vs-checkbox  class="inline-flex mt-2" v-model="applyTable._approved" ><div class="con-vs-chip vs-chip-primary con-color" style="
                                cursor : pointer;
                                background-color: #2935b5 !important;
                                color:#fff;
                                line-height:1;
                                padding:3px 10px;
                                margin:10px 0; 
                                font-size:13px;
                                min-width:50px;
                            ">
                                <span style="margin:0" class="text-chip vs-chip--text">
                                발매승인
                            </span><!----></div></vs-checkbox>
                    <vs-checkbox  class="inline-flex mt-2" v-model="applyTable._trash" ><div class="con-vs-chip vs-chip-primary con-color" style="
                        cursor : pointer;
                        background-color: #808080 !important;
                        color:#fff;
                        line-height:1;
                        padding:3px 10px;
                        margin:10px 0; 
                        font-size:13px;
                        min-width:50px;
                    ">
                        <span style="margin:0" class="text-chip vs-chip--text">
                            임시삭제
                    </span><!----></div></vs-checkbox>
                            
            </div>
            <div class="flex items-center mb-3">
                <div class="flex items-center ">
                    <v-select class="searchSelect" placeholder="검색조건"   v-model='applyTable.keywordType' :clearable="false" :options="applyTable.keywordOption"
                    :reduce="optionData => optionData.value"
                    clearable
                    />
                    <vs-input class="inputx" v-on:keyup.enter="listCall" v-model="applyTable.keyword" />
                    <vs-button @click="applyTable.currentPage = 1; listCall()" class="mr-3 ml-3 inline ">검색</vs-button>
                    <vs-button @click="resetSearch" class="mr-2 ml-2 inline ">초기화</vs-button>
                </div>          
            </div>
            <p>검색 수 : {{ applyTable.filtered }}</p>
            <ag-grid-vue
                style="height:550px; "
                ref="advanceList"
                class="ag-theme-material w-100 ag-grid-table"
                :gridOptions="applyTable.gridOptions"
                :columnDefs="applyTable.columnDefs"
                :rowData="applyTable.listData"
                :defaultColDef="applyTable.defaultColDef"
                :paginationPageSize="applyTable.pageSize"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                :suppressPaginationPanel="false"
                suppressMenuHide="false"
                >
            </ag-grid-vue>
            <div class="paginationBox">
                <base-pagination :page-count="applyTable.totalPage" v-model="applyTable.currentPage"></base-pagination>
            </div>
        </div>
        <div class="vx-col sm:w-2/5 w-full" style="height: 700Px;">
            <FullCalendar
                id="fullCalendarDay"
                :options="calendarDayOptions"
                ref="fullCalendarDay"
              >
              <template v-slot:eventContent='data'>
                <div class='calendarInfo' v-if="data.view.type == 'dayGridMonth'">
                  <div @click="openMonthAlert(data)">
                    임시저장 : {{data.event.extendedProps.data.temporary}}  <br>
                    접수 : {{data.event.extendedProps.data.registration_complete}}  <br>
                    검수완료 : {{data.event.extendedProps.data.inspection_complete}}  <br>
                    유통완료 : {{data.event.extendedProps.data.distribution_complete}}  <br>
                    발매완료 : {{data.event.extendedProps.data.release_complete}}  <br><br>
                  </div>
                  <p  @click="openEditSlot(data.event.extendedProps.data)"><span class='count'>발매확정 : {{data.event.extendedProps.data.count_albums}} </span> / <span class='slot'>SLOT : {{data.event.extendedProps.data.count_slots}} </span></p>  
                </div>
                <div v-else>
                    <div class='calendarInfo' style="position: relative;">
                      <span class='count'>발매확정 : {{data.event.extendedProps.data.count_albums}} </span> / <span class='slot'>SLOT : {{data.event.extendedProps.data.count_slots}} </span>
                    </div>
                    <ul class="calendarAlbumList mt-5" v-if="data.event.extendedProps.data.albums">
                      <li class="" v-for="item,index in data.event.extendedProps.data.albums" @click="handleEventClick(item)">
                        <div :class="[{'t_only_korea' :item.tags_v2.indexOf('t_only_korea') > -1} ,{'t_except_korea' :item.tags_v2.indexOf('t_except_korea') > -1 }]">
                            <p style="font-size: 13px;">{{item.artists}} - {{item.name}} / {{item.licensor}} / {{item.release_type ? item.release_type.toUpperCase() : '-'}} / {{ item.track_count}}</p>
                            <p style="font-size:12px; font-weight: bold;">
                                <!-- <span v-for="tag in item.tags_v2">
                                    {{tagList[tag]}}
                                </span> -->
                                <span v-if="item.tags_v2.indexOf('exposure') > -1">※</span>
                                <span v-if="item.tags_v2.indexOf('magazine') > -1">★</span>
                                <span v-if="item.tags_v2.indexOf('release_time') > -1">☾</span>
                                <span v-if="item.tags_v2.indexOf('has_mv') > -1">M</span>
                                <span v-if="item.tags_v2.indexOf('has_beat') > -1">B</span>
                                <span v-if="item.tags_v2.indexOf('marketing_rec') > -1">♣</span>
                                <span v-if="item.tags_v2.indexOf('genre_ccm') > -1">✝</span>
                                <span v-if="item.tags_v2.indexOf('t_only_korea') > -1">K</span>
                                <span v-if="item.tags_v2.indexOf('t_except_korea') > -1">G</span>
                                <!-- 'exposure' : '※', 
                                'magazine' : '★', 
                                'release_time' : '☾', 
                                'has_mv' : 'M', 
                                'has_beat' : 'B', 
                                'marketing_rec' : '♣', 
                                'genre_ccm' :'✝', 
                                't_only_korea' : 'K', 
                                't_except_korea' :'G' -->
                            </p>
                        </div>
                      </li>
                    </ul>
                  <!-- <span class='count'>발매확정 : {{data.event.extendedProps.data.count_albums}} </span> / <span class='slot'>SLOT : {{data.event.extendedProps.data.count_slots}} </span>   -->
                </div>
              </template>
              
            </FullCalendar>
        </div>
        <v-modal name="calendar" 
            :width="'100%'"
            :maxWidth="400"
            height="auto"
            :adaptive="true"
            >
            <div class="onlyDark">
                <div style="padding:0.5rem 1rem; font-size: 16px;" class="card-color ">
                <strong style="font-size:16px; " class="modalCont darkWhiteColor">일정 상세보기</strong>
                </div>
                <div style="padding:1rem; text-align:center; word-break:keep-all; font-size: 15px;" class="modalCont darkWhiteColor" >
                <div style='text-align:left' v-if=" Object.keys(popData).length > 0">
                    <div >
                        태그 : 
                        <p style="font-size: 12px; font-weight: bold; display: inline;">
                            <span v-if="popData.tags_v2.indexOf('exposure') > -1"> ※ </span>
                            <span v-if="popData.tags_v2.indexOf('magazine') > -1"> ★ </span>
                            <span v-if="popData.tags_v2.indexOf('release_time') > -1"> ☾ </span>
                            <span v-if="popData.tags_v2.indexOf('has_mv') > -1"> M </span>
                            <span v-if="popData.tags_v2.indexOf('has_beat') > -1"> B </span>
                            <span v-if="popData.tags_v2.indexOf('marketing_rec') > -1"> ♣ </span>
                            <span v-if="popData.tags_v2.indexOf('genre_ccm') > -1"> ✝ </span>
                            <span v-if="popData.tags_v2.indexOf('t_only_korea') > -1"> K </span>
                            <span v-if="popData.tags_v2.indexOf('t_except_korea') > -1"> G </span>
                        </p>
                    </div>
                    앨범명 : {{popData.name}}
                    <br/>
                    권리자명 : {{popData.licensor}}
                    <br/>
                    아티스트 : {{popData.artists}}
                    <br/>
                    앨범형식 : {{popData.release_type? popData.release_type.toUpperCase() : popData.release_type}}
                    <br/>
                    트랙수 : {{popData.track_count}}
                    <br/>
                    담당자 : {{popData.sr_representative}}
                    <p>
                    
                    <router-link :to="{ path: '/album/detail/'+ popData.id }" style="float:right;" target="_blank"> 
                        <button style="padding:5px 10px; background:rgba(var(--vs-primary), 1) !important; border:0; border-radius: 5px; color :#fff; font-size: 13px;">
                        앨범 상세보기
                        </button>
                    </router-link>
                    </p>
                    <br/>
                </div>
                </div>
            </div>
        </v-modal>
    </div>
</template>

<script>


import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import agTableComp from '@/optionData/agTableComp'

const today = new Date()
export default{
    components: {
        
    },
    data () {
        return{
            ko : ko,
            startDate : null,
            endDate : null,
            tagList: {
                'exposure' : '※', 
                'magazine' : '★', 
                'release_time' : '☾', 
                'has_mv' : 'M', 
                'has_beat' : 'B', 
                'marketing_rec' : '♣', 
                'genre_ccm' :'✝', 
                't_only_korea' : 'K', 
                't_except_korea' :'G'
            },
            applyTable : {
                _registered : false,
                _rejected : false, 
                _onhold : false,
                _approved : false,
                _trash : false,
                keywordOption : [
                    {label : '앨범명',value : 'album_title'},
                    {label : '앨범아티스트',value : 'album_artist'},
                    {label : '신청자명',value : 'name'},
                    {label : '회사명',value : 'company'},
                    {label : '이메일',value : '_email'},

                ],
                keywordType : null,
                keyword : null,
                sourceOption: [
                    {label : '전체',value : null},
                    {label : '회원',value : 'member'},
                    {label : '비회원',value : 'non_member'},
                    {label : 'DDEX',value : 'member_ddex'},
                ],
                source : null,
                langOption : [
                    {label : '전체',value : null},
                    {label : '한국어',value : 'ko'},
                    {label : '영어',value : 'en'},
                ],
                language : null,


                listData: [  
                    
                ],                 
                pageSize: 10,                 
                currentPage: 1,
                totalPage: 0,
                total : 0,
                gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
                context: {
                    componentParent: this
                },
                frameworkComponents :agTableComp,
                defaultColDef: {
                    domLayout:'auto',
                    sortable: false,
                    editable: false,
                    resizable: true,
                    suppressMenu: false,
                    rowSelection:'single'
                },
                },
                columnDefs : [
                    {headerName: '접수일',      field: 'created_at',     filter: false,width: 120,
                    cellRenderer: (data) => {
                        let text =  this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                        return `<div class="cellCenter textCenter">${text}</div>`
                    }},
                    {headerName: '관리상태', field: 'state', filter: false,resizable : true, width: 100,cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.$router.push('/calendar/detail/'+data.id)
                        },
                        },
                        cellRendererSelector: (data) => {
                            let dd = {
                                registered : "발매신청",
                                approved : '발매승인',
                                rejected : '발매거절',
                                on_hold : '발매보류',
                                trash : '임시삭제'
                            }
                            let color = {
                                registered : "#4aa414",
                                approved : '#2935b5',
                                rejected : '#ba2727',
                                on_hold : '#c3a433',
                                trash : '#808080'
                            }
                            let html =  `
                            <div class="con-vs-chip vs-chip-primary con-color" 
                            style="
                                cursor : pointer;
                                background-color: ${color[data.value]} !important;
                                color:#fff;
                                line-height:1;
                                padding:3px 10px;
                                margin:10px 0; 
                                font-size:13px;
                                min-width:50px;
                            ">
                                <span style="margin:0" class="text-chip vs-chip--text">
                                ${dd[data.value]}
                            </span><!----></div>`
                            let dom = {
                                component: 'textButton',
                                params: {
                                    ...data.data,
                                    text: html,
                                }
                            } ;
                            // if(this.selectTrack.track_id ==  data.data.track_id ){
                            //     dd.params['disabled'] = true
                            //     dd.params['title'] = '선택완료'
                            // }
                            
                            return dom
                        } },
                    
                    
                    {headerName: '언어/접수유형', field: 'source', filter: false,width: 120, cellRenderer: (data) => {
                        let t = data.data.language
                        let text =  t? t.toUpperCase() : ''
                        let dd = {
                            member_ddex : "DDEX",
                            non_member : '비회원',
                            member : '회원',
                        }
                        return `
                       ${text} - ${ dd[data.value]}`
                    }},
                    {headerName: '앨범/아티스트명', field: 'album_title', filter: false,width: 200,cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.applyTable.keyword = data.album_title;
                            this.context.componentParent.applyTable.keywordType = 'album_title';
                            this.context.componentParent.applyTable.currentPage = 1
                            this.context.componentParent.listCall()
                        },
                        clicked2: function(data) {
                            console.log(data)
                            this.context.componentParent.applyTable.keyword = data.album_artist;
                            this.context.componentParent.applyTable.keywordType = 'album_artist';
                            this.context.componentParent.applyTable.currentPage = 1
                            this.context.componentParent.listCall()
                        },
                        },
                        cellRendererSelector: (data) => {
                            let name = data.value ? data.value : null 
                            let company = data.data.album_artist? data.data.album_artist : null
                            // if(!this.valCheck(company)){
                            //     name = name + '<br>'+ company
                            // }
                            
                            let dd={
                                component: 'textButton2',
                                params: {
                                    ...data.data,
                                    text: name ? `<div class="cellCenter"> <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis; max-width:100%;"> ${name}</div></div>` : null, 
                                    text2: company ? `<div class="cellCenter"> <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis; max-width:100%;"> ${company}</div></div>` : null,
                                    style: 'cursor : pointer'
                                }
                            } ;
                            // if(this.selectTrack.track_id ==  data.data.track_id ){
                            //     dd.params['disabled'] = true
                            //     dd.params['title'] = '선택완료'
                            // }
                            
                            return dd
                        }
                    },
                    {headerName: '신청자/회사명', field: 'name', filter: false, minWidth:140, width: 150, cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.applyTable.keyword = data.name;
                            this.context.componentParent.applyTable.keywordType = 'name';
                            this.context.componentParent.applyTable.currentPage = 1
                            this.context.componentParent.listCall()
                        },
                        clicked2: function(data) {
                            this.context.componentParent.applyTable.keyword = data.company;
                            this.context.componentParent.applyTable.keywordType = 'company';
                            this.context.componentParent.applyTable.currentPage = 1
                            this.context.componentParent.listCall()
                        },
                        },
                        cellRendererSelector: (data) => {
                            let name = data.value ? data.value : null 
                            let company = data.data.company ? data.data.company : null
                            // if(!this.valCheck(company)){
                            //     name = name + '<br>'+ company
                            // }
                            
                            let dd={
                                component: 'textButton2',
                                params: {
                                    ...data.data,
                                    text: name ? `<div class="cellCenter"> <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis; max-width:100%;"> ${name}</div></div>` : null, 
                                    text2: company ? `<div class="cellCenter"> <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis; max-width:100%;"> ${company}</div></div>` : null,
                                    style: 'cursor : pointer'
                                }
                            } ;
                            // if(this.selectTrack.track_id ==  data.data.track_id ){
                            //     dd.params['disabled'] = true
                            //     dd.params['title'] = '선택완료'
                            // }
                            
                            return dd
                        }
                    },
                    
                    {headerName: '발매희망일시',  field: 'desired_release_date',  filter: false,width: 150,cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.daySet(data.desired_release_date);
                        },
                        },
                        cellRendererSelector: (data) => {
                            let text = data.data.desired_release_time ? this.fixDate('2000-01-01 '+ data.data.desired_release_time, 'HH:mm')  : null 
                            console.log(text)
                            let dd={
                                component: 'textButton',
                                params: {
                                    ...data.data,
                                    text: data.value + ' <br>'  +text ,
                                    style: 'text-align:center; color: rgba(var(--vs-primary), 1); cursor : pointer'
                                }
                            } ;
                            // if(this.selectTrack.track_id ==  data.data.track_id ){
                            //     dd.params['disabled'] = true
                            //     dd.params['title'] = '선택완료'
                            // }
                            
                            return dd
                        }
                    },
                    {headerName: '발매확정일',  field: 'album.release_date',  filter: false,width: 120,cellRendererParams: {
                        clicked: function(data) {
                            if(data.album){
                                this.context.componentParent.daySet(data.album.release_date);
                            }
                            
                        },
                        },
                        cellRendererSelector: (data) => {

                            let text1 = data.data.album ? data.data.album.release_date  : null 
                            let text2 = data.data.album && data.data.album.release_time ? this.fixDate('2000-01-01 '+ data.data.album.release_time, 'HH:mm')  : null 
                            let dd = {
                                component: 'textButton',
                                params: {
                                    ...data.data,
                                    
                                    text: text1 ? text1+ ' ' + text2 : '',
                                    style: 'text-align:center; color: rgba(var(--vs-primary), 1); cursor : pointer'
                                }
                            } ;
                            // if(this.selectTrack.track_id ==  data.data.track_id ){
                            //     dd.params['disabled'] = true
                            //     dd.params['title'] = '선택완료'
                            // }
                            
                            return dd
                        }
                    },
                    
                ],
            },
            calendarDayOptions: {
                locale: 'ko',
                plugins: [dayGridPlugin,interactionPlugin],
                theme: true,
                headerToolbar: {
                left: 'prev',
                center: 'title',
                right: 'next',
                },
                selectable: false,
                selectHelper: true,
                editable: false,
                initialView: 'dayGridDay',
                initialDate: today,
                initialEvent: this.events,
                events : this.events,
                height: '100%',
                //eventsSet: this.handleEvents,
                eventLimit: true,
                
                dateClick:this.handleDateClick,
                fixedWeekCount: false,
                eventColor: 'transparent',
                customButtons: {
                prev: {
                    text: 'PREV',
                    click: () => {
                        const calendarApi = this.$refs.fullCalendarDay.getApi()
                        calendarApi.prev()
                        const currentStart = calendarApi.view.activeStart
                        this.dayCall(currentStart)
                    
                    },
                },
                next: {
                    text: 'NEXT',
                    click: () => {
                        const calendarApi = this.$refs.fullCalendarDay.getApi()
                        calendarApi.next()
                        const currentStart = calendarApi.view.activeStart
                        this.dayCall(currentStart)
                        
                    },
                },
                today: {
                    text: 'TODAY',
                    click: () => {
                        const calendarApi = this.$refs.fullCalendarDay.getApi()
                        calendarApi.today()
                        const currentStart = calendarApi.view.activeStart
                        this.dayCall(currentStart)
                    },
                },
                },
                
            },
            popData : {},
        }
    },
    watch: {
        'applyTable.currentPage'(){
            this.listCall()
        }
    },
    mounted () {
         if(this.$route.query.keywordType){
            this.applyTablekeywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.applyTable.keyword= this.$route.query.keyword
        }
        if(this.$route.query.language){
            this.applyTable.language= this.$route.query.language
        }
        
        if(this.$route.query['startDate'] && this.$route.query['endDate'] ) {
            this.startDate = this.$route.query['startDate'] 
            this.endDate = this.$route.query['endDate'] 
        }
        if(this.$route.query.page){
            this.applyTable.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.applyTable.keywordType = this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.applyTable.keyword= this.$route.query.keyword
        }

        if(this.$route.query._registered){
            this.applyTable._registered= this.$route.query._registered
        }
        if(this.$route.query._approved){
            this.applyTable._approved= this.$route.query._approved
        }
        if(this.$route.query._onhold){
            this.applyTable._onhold= this.$route.query._onhold
        }
        if(this.$route.query._rejected){
            this.applyTable._rejected= this.$route.query._rejected
        }

        this.$nextTick(()=>{
            this.listCall()
            const calendarApi = this.$refs.fullCalendarDay.getApi()
            
            const currentStart = calendarApi.view.activeStart
            this.dayCall(currentStart)
        })
    },
    computed:{
        
    },
    methods:{
        resetSearch(){
            this.applyTable.keyword = null
            this.startDate = this.endDate = null
            this.applyTable._approved =false
            this.applyTable._onhold =false
            this.applyTable._registered =false
            this.applyTable._trash =false
            this.applyTable._rejected =false
            this.applyTable.language = null
            this.applyTable.source = null
            this.applyTable.currentPage =1
            this.listCall()
        },

        handleEventClick (info) {
            this.popData = info
            this.openModal('calendar')
        },
        listCall(){
            this.loadingShow()
            const option = {
                sort: 'created_at',
                sortorder: 'desc',
                page: this.applyTable.currentPage-1 ,
                limit: this.applyTable.pageSize,
            }
            let query = {
                
            }
            if(this.applyTable.currentPage != 1){
                query['page'] = this.applyTable.currentPage
            }
            
            if(this.applyTable.keywordType && !this.valCheck(this.applyTable.keyword) ) {
                option[this.applyTable.keywordType] = this.applyTable.keyword
                query['keywordType'] = this.applyTable.keywordType
                query['keyword'] = this.applyTable.keyword
            }
            if( !this.valCheck(this.applyTable.source)){
                query['source'] = this.applyTable.source
                option['source'] = this.applyTable.source
            }
            if( !this.valCheck(this.applyTable.language)){
                query['language'] = this.applyTable.language
                option['language'] = this.applyTable.language
            }
            if( !this.valCheck(this.applyTable._registered)){
                query['_registered'] = true
                option['_registered'] = 'y'
            }
            if( !this.valCheck(this.applyTable._rejected)){
                query['_rejected'] = true
                option['_rejected'] = 'y'
            }
            if( !this.valCheck(this.applyTable._onhold)){
                query['_onhold'] = true
                option['_onhold'] = 'y'
            }
            if( !this.valCheck(this.applyTable._approved)){
                query['_approved'] = true
                option['_approved'] = 'y'
            }
            if( !this.valCheck(this.applyTable._trash)){
                query['_trash'] = true
                option['_trash'] = 'y'
            }
            
            if(!this.valCheck(this.startDate) && !this.valCheck(this.endDate) ){
                option['startDate'] = this.startDate
                query['startDate'] = this.startDate
                option['endDate'] = this.endDate
                query['endDate'] = this.endDate
            }
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.$store.dispatch('GET_APPLICATION', option)
            .then(result =>{
                this.loadingHide()
                this.applyTable.listData  = result.items // 권리자 목록
                this.applyTable.total = result.total // 총인원수 
                this.applyTable.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(result.filtered % this.applyTable.pageSize) > 0 ? 1: 0
                this.applyTable.totalPage = parseInt(result.filtered/this.applyTable.pageSize) + remainder
                
            }).catch(error=>{
                this.loadingHide()
                const status = error.response.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg:error.response.data.message })
                    break;
                }
            })
        },
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        dayCall(date){
            let format = this.fixDate(date, 'yyyy-MM-dd')
            let payload = {
                start : format
            }
            this.loadingShow()
            this.$store.dispatch('GET_CALENDAR_DAY', payload)
            .then(result =>{
                this.loadingHide()
                this.calendarDayOptions.events = []
                result.forEach((album,index) => {
                    const event = {}
                    event.id = index 
                    event.start = album.date
                    event.extendedProps = {}
                    event.extendedProps.data = album
                    event.extendedProps.title = 'ddd'
                    this.calendarDayOptions.events.push(event)
                })
            }).catch(error=>{
                this.loadingHide()
                 
            })
        },
        daySet(date){
            const calendarApi = this.$refs.fullCalendarDay.getApi()
            calendarApi.gotoDate(date)
            this.dayCall(date)
        },
        typeText(val){
            let dd = {
                temporary :'임시저장',
                registration_complete : '접수', 
                registration_canceled : '유통 취소', 
                inspection_complete : '검수 완료', 
                distribution_complete : '유통 완료', 
                release_complete : '발매 완료', 
                suspended : '유통중단', 
                rejected : '반려',
                trash : '임시삭제'
            }
            let color = {
                temporary : "#9544d0b3",//'임시저장',
                registration_complete : '#747ca4',//'접수', 
                registration_canceled : '#797979',//'유통 취소', 
                inspection_complete : '#4092ff',//'검수 완료', 
                distribution_complete : '#ff9f43',//'유통 완료', 
                release_complete : '#24c1a0',//'발매 완료', 
                suspended : '#b8c2cc',//'유통중단', 
                rejected : '#ea5455',//'반려' 
                trash : "#737373"
            }
            if(dd.hasOwnProperty(val)){
                return `
                        <div class="con-vs-chip vs-chip-primary con-color" 
                        style="
                            background-color: ${color[val]} !important;
                            color:#fff;
                            line-height: 1;
                            padding: 1px 5px;
                            font-size: 11px;
                            float: none;
                            min-width: 50px;
                            display: inline-block;
                            min-height: 0;
                        ">
                            <span style="margin:0" class="text-chip vs-chip--text">
                            ${dd[val]}
                </span><!----></div>`
            }else {
                return 'type'
            }
            
        },
    }
}
</script>

<style lang="scss">

</style>
